import { render, staticRenderFns } from "./DocutaxSubmissionStatus.vue?vue&type=template&id=2b0b2eb8&"
import script from "./DocutaxSubmissionStatus.vue?vue&type=script&lang=js&"
export * from "./DocutaxSubmissionStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports